var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcCall24X24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.21 14.867a24.82 24.82 0 0 0 7.307 5.051c.723.326 1.565.143 2.125-.418l1.844-1.843a2 2 0 0 0 0-2.829l-2.122-2.12a1 1 0 0 0-1.414 0l-2.47 2.47a12.432 12.432 0 0 1-3.292-2.366 12.433 12.433 0 0 1-2.365-3.291l2.47-2.47a1 1 0 0 0 0-1.415L9.172 3.515a2 2 0 0 0-2.828 0L4.5 5.358c-.56.56-.744 1.403-.418 2.125a24.816 24.816 0 0 0 5.051 7.307l.078.077Z",
  fill: "#0C1120"
})));
export default SvgIcCall24X24;